<style scoped>
.requireText label:before{
  content: '* ';
  color: red;
}
</style>

<template>
  <div style="padding: 15px;width:100%">
    <Card >
      <Row>
        <Button class="" style="margin-bottom: 10px;" type="info" @click="backPage">返回</Button>
      </Row>
      <Row>
        <!-- border:1px solid #dcdee2; -->
        <Col >
          <Row>
            <div style="display: flex;flex-direction: row;">
            <div style="margin-right: 20px;font-weight: bold;color:#000000; background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px; font-size: 18px;"><span style="font-weight: bold; font-size: 18px;">序号：</span>{{ objFenge._index+1 }}
            </div>
            <div style="margin-right: 20px;font-weight: bold;color:#000000; background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px; font-size: 18px;"><span style="font-weight: bold; font-size: 18px;">订单号：</span>{{ objFenge.code }}
            </div>
            <div style="margin-right: 20px;font-weight: bold;color:#000000; background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px; font-size: 18px;"><span style="font-weight: bold; font-size: 18px;">产品名称：</span>{{ objFenge.name }}
            </div>
          </div>
          </Row>
        <Row>
          <div style="display: flex;flex-direction: row;">
           
            <div style="margin-right: 30px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold;">分割幅宽(mm):</span>{{ objFenge.splitsWideStr }}</div>
            <div style="margin-right: 30px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold;">分割长度(m):</span>{{ objFenge.splitsOneLength }}</div>
            <div style="margin-right: 30px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold;">分割数:</span>{{ objFenge.spliteNo }}</div>
            <div style="margin-right: 30px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold;">分割总长度:</span>{{ objFenge.splitsTotalLength }}
            </div>
            <div style="margin-right: 30px;font-weight: bold;color:#000000; font-size: 18px;background-color: #FFFFFF;border-radius: 4px; padding: 2px 6px;"><span style="font-weight: bold;">已分割长度:</span>{{ numObjSvn }}
            </div>
              <Button class="" style="padding:2px 15px;background:rgb(60, 212, 151) !important;color:white;border-color :rgb(60, 212, 151) !important" type="primary" @click="okm">完成</Button>
          </div>
        </Row>
<Row>
  &nbsp;
</Row>
        <Row>
          <Form inline :label-width="90" class="basicForm" ref="searchForm" :model="searchForm">
            <FormItem class="form-item " label="" :label-width="0"
              style="width: 350px;margin-bottom: 5px;margin-top: 10px;">
              <Button class="" type="primary" @click="searchBtnNew" :loading="loading">选择物料</Button>
              <!-- <Button class="" type="primary" @click="heChFun" :loading="loading">分割</Button> -->
              <Button class="" type="primary" @click="searchBtn" >贴标</Button>
            </FormItem>
          </Form>
          <Table class="table" border @on-selection-change="selectTab"  ref="tableDataOneTab" :data="tableDataOne" :columns="tableColumnsOne" :loading="loading" highlight-row
            stripe>
          </Table>
          <Form inline :label-width="130" style="display: flex;flex-direction: row;align-items: center;margin-left: 80%;" >
            <FormItem class="form-item"  label="累计分割长度：" style="margin-bottom: 0;margin-top: 10px;margin-right: 50px;">
              <div>{{ sumLength }}m</div>
              </FormItem>
            <FormItem class="form-item " label="" :label-width="0"
              style="width: 120px;margin-bottom: 5px;margin-top: 10px;">
              <Button class="" type="primary" @click="heChFun" :loading="loading">分割</Button>
            </FormItem>
          </Form>
        </Row>
        </Col>

      </Row>
    </Card>
    <Card style="margin-top: 15px;">
      <!-- <Col  style=""> -->
      <Row>
        <Form inline :label-width="90" class="basicForm" ref="searchFormEch" :model="searchFormEch">
          <FormItem class="form-item" label="宽" >
            <Input class="width90" type="text" clearable v-model.trim="searchFormEch.wide"
              placeholder="请输入" />
          </FormItem>
          <FormItem class="form-item" label="长">
            <Input class="width90" type="text" clearable v-model.trim="searchFormEch.spLengths"
              placeholder="请输入" />
          </FormItem>
          <FormItem class="form-item" label="客户名称">
            <Select v-model="searchFormEch.customer" class="width160" clearable filterable placeholder="请选择">
                    <Option v-for="item in customerList" :value="item" :key="item" :label="item"></Option>
                  </Select>
          </FormItem>
         
          <FormItem class="form-item" label="类型">
            <Select v-model="searchFormEch.type" transfer clearable class="width160">
            <Option value="库存">库存</Option>
            <Option value="损耗">损耗</Option>
            <Option value="撤回">撤回</Option>
          </Select>
          </FormItem>
          <FormItem class="form-item" label="" :label-width="0" style="width: 185px;margin-left: 50px;">
            <Button class="" type="primary" @click="getCutPaperPasteListFun" :loading="loading">查询</Button>
            <Button class="" type="primary" @click="searchBtnSSS" :loading="loading">贴标</Button>
          </FormItem>
        </Form>
      </Row>
      <Row class="" style="display: flex;
          flex-direction: column;">
        <Table class="table" border ref="tableDataSet"  :data="tableData" :columns="tableColumnRight" :loading="loading" highlight-row
          stripe>
        </Table>
        <Page :current="pageNum" :page-size="pageSize" :total="total" @on-change="handleChangePage"
          @on-page-size-change="handlePageSizeChange" show-total show-sizer
          style="margin-top:10px;text-align: center;" />
      </Row>
      <!-- </Col> -->
    </Card>
    <Modal :title="titleType" v-model="proSelectModals" width="1200" footer-hide style="display: flex;
      flex-direction: column;">
      <Form inline :label-width="80" class="basicForm" ref="proSelectForm">
        <!-- <FormItem class="form-item" label="类型">
          <Select v-model="proSelectForm.type" style="width: 120px;" transfer clearable class="width160">
            <Option value="一级">一级</Option>
            <Option value="二级">二级</Option>
          </Select>
        </FormItem> -->
        <FormItem class="form-item" label="物料编码">
          <Input class="width160" type="text" style="width: 120px;" clearable v-model.trim="proSelectForm.code" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item" label="幅宽">
          <Input class="width160" type="text" style="width: 120px;" clearable v-model.trim="proSelectForm.splitsWide" placeholder="请输入..." />
        </FormItem>
        <FormItem class="form-item">
          <Button type="primary" @click="searchBtnNew">查询</Button>
        </FormItem>
      </Form>
      <Row class="marginTop20">
        <Table :height="600" class="table" ref="proSelectTab" border :data="proSelectData" :columns="proSelectColumns"
          highlight-row stripe>
        </Table>
      </Row>
      <Row style="display: flex;flex-direction: row; align-items: center; justify-content: center;margin-top: 10px;">
        <Button type="primary" @click="sureProBtn">添加</Button>
        <Button @click="proSelectModals = false" class="marginLeft20" style="width: 70px;margin-left: 20px;">取消</Button>
      </Row>

    </Modal>
    <Modal title="修改" v-model="changeEquipFlag" footer-hide>
      <Form :label-width="90" inline>
        <FormItem label="剩余长度" >
          <Input class="width160" type="text" style="width: 200px;" clearable v-model.trim="changeEquip.lengths" placeholder="请输入..." />
        </FormItem>
      </Form>
      <Row style="text-align: center;margin-left: 35%">
        <Button type="primary" @click="submitChangeEquip" style="width: 70px">确定</Button>
        <Button @click="changeEquipFlag = false" class="marginLeft20" style="width: 70px; margin-left:20px">取消</Button>
      </Row>
    </Modal>
    <Modal title="修改" v-model="allFormFlag" footer-hide>
      <Form :label-width="90" inline>
        <FormItem class="form-item" label="类型">
            <Select v-model="allForm.type" style="width: 200px;" class="width160">
            <Option value="库存">库存</Option>
            <Option value="损耗">损耗</Option>
            <Option value="撤回">撤回</Option>
          </Select>
          </FormItem>
      </Form>
      <Row style="text-align: center;margin-left: 35%">
        <Button type="primary" @click="submitAllForm" style="width: 70px">确定</Button>
        <Button @click="allFormFlag = false" class="marginLeft20" style="width: 70px; margin-left:20px">取消</Button>
      </Row>
    </Modal>
  </div>
</template>

<script>
import { formatDate } from "@/api/util";
import { getOverallList, getCutPaperPasteOpt,cutCommonDecals,decalsSplits,cutCommonFulfill,getCustomerListSplitsMaterial,updateHavePaperSplitsStatus,splitsGoodsStockOpt,saveRemLength,deleteSelectGoodsStock, getPasteInfo,saveGoodsStockToSpMaterial,getGoodsStockList,getNum, cutPaperPasteOptAdd,getSplitsMaterialList,getRecallPastePaper,getPasteFinishList,updateCutPaperPasteOpt,pastePaper,getPartDeleteById } from '@/api/index'
import { FormItem } from "view-design";
export default {
  name: "fenGAdd",
  data() {
    return {
      searchFormEch:{},
      allForm:{},
      sumLength:0,
      allFormFlag:false,
      processData: [],
      pageNum:1,
      pageSize:10,
      total:0,
      searchForm: {},
      objFuhe: {},
      objFenge:{},
      tableData: [],
      proSelectData: [],
      proSelectForm:{},
      tableDataOne: [],
      tableDataTwo: [],
      tableDataThree: [],
      tableDataFour: [],
      proSelectModals: false,
      changeEquipFlag: false,
      
      titleType: '',
      loading: false,
      tableColumns: [
        {
          title: "序号",
          type: "index",
          width: 70,
          align: "center"
        },
        {
          key: "name",
          title: "工序",
          align: "center",
        },
        {
          key: "complete",
          title: "已完成",
          align: "center",
        },
        {
          key: "noComplete",
          title: "未完成",
          align: "center",
        },
        {
          key: "rate",
          title: "进度",
          align: "center",
          render: (h, params) => {
            let data = params.row.rate + '%';
            return h("span", data);
          }
        },
      ],
      tableColumnsOne: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed:'left'
        },
        {
            title: "类型",
            key: "matType",
            align: "center",
            width: 200,
          },
        {
          key: "code",
          title: "编号",
          align: "center",
          width: 300,
        },
        {
          key: "name",
          title: "名称",
          align: "center",
          width: 350,
        },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          width: 250,
        },
        {
          key: "lengths",
          title: "剩余长度(m)",
          align: "center",
          width: 270,
        },
        {
          title: '分割长度(m)',
          key: 'spLengths',
          align: 'center',
          width: 250,
          render: (h, params) => {
            let _this = this;
            return h('Input', {
              style: {
                width: '100%',
                textAlign: 'center'
              },
              props: {
                value: params.row.spLengths || '',
                type: 'number'
              },
              on: {
                'on-change': e => {
                  if (e.target.value !== '' && e.target.value !== null && e.target.value !== undefined) {
                    params.row.spLengths = Number(e.target.value);
                  } else {
                    params.row.spLengths = e.target.value;
                  }
                  this.$set(_this.tableDataOne, params.index, params.row);

                }
              }
            });

          }
        },
        {
          title: "操作",
          key: "action",
          width: 170,
          fixed: 'right',
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "button", {

                  style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#FF0000',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                on: {
                  click: () => {
                    this.recallApply(params.row);
                  }
                }
              },
                "删除"
              ),
              h(
                                    "button", {
                                       
                                      style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                                        on: {
                                            click: () => {
                                              this.changeEquipFlag = true
                                              this.changeEquip = JSON.parse(JSON.stringify(params.row))
                                            }
                                        }
                                    },
                                    "修改"
                                ),
            ]);
          }
        }
      ],
      changeEquip:{},
      tableColumnRight: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed: 'left'
        },
        {
          key: "knifeCode",
          title: "分割编号",
          align: "center",
          // width: 150,
        },
        {
          key: "name",
          title: "名称",
          align: "center",
          // width: 150,
        },
        {
          key: "code",
          title: "物料编号",
          align: "center",
          // width: 150,
        },
       
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          // width: 150,
        },
        {
          key: "spLengths",
          title: "长(m)",
          align: "center",
          // width: 150,
        },
        {
          key: "phyLengths",
          title: "长(m工单)",
          align: "center",
          // width: 150,
        },
        {
          key: "type",
          title: "类型",
          align: "center",
             render: (h, params) => {
            let data = "";
            let className = '';
            switch (params.row.type) {
              case "撤回":
                data = "撤回";
                className = 'grey';
                break;
              case "库存":
                data = "库存";
                className = '#3CD497';
                break;
                case "损耗":
                data = "损耗";
                className = '#FF964A';
                break;
            }
            return h(
             "button", {
                 style: {
                            marginRight: "10px",
                            display:"inline",
                            cursor: 'pointer',
                            padding:"2px 6px",
                            background:'none',
                            color:className,
                            // borderRadio:'5px',
                            border:className,
                          },
                attrs: {
                    class: className
                  }
            },
              data
            )
          }
        },
        {
          key: "customer",
          title: "客户名称",
          align: "center",
          // width: 150,
        },
        // {
        //   title: "状态",
        //   key: "status",
        //   align: "center",
        //   // width: 100,
        //   render: (h, params) => {
        //     let data = "";
        //     let className = '';
        //     switch (Number(params.row.status)) {
        //       case 0:
        //         data = "撤销";
        //         className = '';
        //         break;
        //       case 1:
        //         data = "正常";
        //         className = '';
        //         break;
        //     }

        //     return h(
        //       "div", {
        //       attrs: {
        //         class: className
        //       }
        //     },
        //       data
        //     )
        //   }
        // },
        {
          key: "operateTime",
          title: "操作时间",
          align: "center",
          // width: 150,
        },
        {
          key: "operator",
          title: "操作人",
          align: "center",
          // width: 150,
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          fixed: 'right',
          align: "center",
          render: (h, params) => {
            return h("div", [
            h(
                                    "button", {
                                       
                                      style: {
                                          marginRight: "10px",
                                          display:"inline",
                                          cursor: 'pointer',
                                          padding:"2px 6px",
                                          background:'#326CFB',
                                          color:"white",
                                          // borderRadio:'5px',
                                          border:"none",
                                        },
                                        on: {
                                            click: () => {
                                                this.allFormFlag = true
                                                this.allForm = JSON.parse(JSON.stringify(params.row))
                                            }
                                        }
                                    },
                                    "修改"
                                ),
            ]);
          }
        }
      ],
      proSelectColumns: [
        {
          type: 'selection',
          align: 'center',
          width: 60,
          // fixed:'left'
        },
        // {
        //   title: "类型",
        //   key: "level",
        //   align: "center",
        //   width: 100,
        //   render: (h, params) => {
        //     let data = "";
        //     let className = '';
        //     switch (Number(params.row.level)) {
        //       case 1:
        //         data = "一级";
        //         className = 'table-status  border-color-blue';
        //         break;
        //       case 2:
        //         data = "二级";
        //         className = 'table-status border-light-red';
        //         break;
        //     }

        //     return h(
        //       "div", {
        //       attrs: {
        //         class: className
        //       }
        //     },
        //       data
        //     )
        //   }
        // },
        {
          key: "itemTypeName",
          title: "类型",
          align: "center",
          width: 100,
        },
        {
          key: "code",
          title: "物料编号",
          align: "center",
          // width: 150,
        },
        // {
        //   key: "brand",
        //   title: "品牌",
        //   align: "center",
        //   // width: 150,
        // },
        {
          key: "wide",
          title: "宽(mm)",
          align: "center",
          // width: 150,
        },
        {
          key: "lengths",
          title: "长(m)",
          align: "center",
          // width: 150,
        },
        // {
        //   title: '克重(kg)',
        //   key: 'weight',
        //   align: 'center',
        //   width: "150",
        // },
      ],
      types: null,
      numObjSvn:null,
      customerList:[],
    }
  },
  methods: {
    okm(){
       this.$Modal.confirm({
                title: "确认",
                content: "是否确认完成?",
                onOk: () => {
                  cutCommonFulfill({
                    id:this.objFenge.id,
                    type:2,
                  }).then( res => {
                    if(res.code == 200){
                      this.$Message.success('操作成功！');
                    }
                  })
                }
              });
    },
    submitAllForm(){
      updateHavePaperSplitsStatus({
        ...this.allForm
      }).then(res => {
        if(res.code == 200){
          this.$Message.success("操作成功")
          this.allFormFlag = false
          this.getCutPaperPasteListFun()
        }
      })
    },
    submitChangeEquip(){
      if(this.changeEquip.lengths <0){
        this.$Message.error("请输入长度")
        return;
      }
      saveRemLength({
        ...this.changeEquip
      }).then(res => {
        if(res.code == 200){
          this.$Message.success("操作成功")
          this.changeEquipFlag = false
          this.getCutPaperPasteOptFun()
        }
      })
    },
    printRow(v){
      let params = {
            id: v.id,
          }
                getRecallPastePaper(params)
                    .then(res =>{
                         if(res.code == 200){
                             window.open(res.data.result,"_blank");
                         }
                    })
            },
    heChFun(){
      const data1 = this.$refs.tableDataOneTab.getSelection();
      if(data1.length == 0){
        this.$Message.error('请勾选需要复合的材料!');
        return
      }
      // if(!this.searchFormEch.pasteLength){
      //   this.$Message.error('请填写长度!');
      //   return
      // }
      splitsGoodsStockOpt(data1).then(res => {
        if(res.code == 200){
          this.$Message.success('复合成功!');
          this.getCutPaperPasteOptFun()
          this.getCutPaperPasteListFun()
        }
      })
    },
    selectTab(v) {
        const data = this.$refs.tableDataOneTab.getSelection();
        let sumLengths = 0
        data.map( item => {
          sumLengths+=Number(item.spLengths)
        })
       this.sumLength = sumLengths
      },
    getCutPaperPasteListFun(){
      let params = {
        data: {
          ...this.searchFormEch,
          parentId: this.objFenge.id,
          dataType:2,
        },
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }
      getSplitsMaterialList(params).then(res => {
        if(res.code == 200){
          this.tableData = res.data.records
          this.total = res.data.total
        }
      })
    },
    recallApply(v) {

      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除吗?",
        onOk: () => {
          let params = {
            id: v.id,
          }
          deleteSelectGoodsStock(params)
            .then(res => {
              if (res.code == 200) {
                this.$Message.success('删除成功!');
                this.getCutPaperPasteOptFun()
              }
            })
        }
      });

    },
    recallApplys(v) {

this.$Modal.confirm({
  title: "确认撤销",
  content: "您确认要撤销吗?",
  onOk: () => {
    let params = {
      id: v.id,
    }
    getRecallPastePaper(params)
      .then(res => {
        if (res.code == 200) {
          this.$Message.success('撤销成功!');
          this.getCutPaperPasteListFun()
        }
      })
  }
});

},
    sureProBtn() {
      const data = this.$refs.proSelectTab.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      let atr = []
      data.map(item => {
        atr.push({
          mid:item.id,
          spId:this.objFenge.id
        })
        // item.mid = item.id
        // item.parentId = this.objFenge.id
      })
      // let params = {
      //   data
      // }
      saveGoodsStockToSpMaterial(atr).then(res => {
        if (res.code == 200) {
          this.$Message.success('保存成功！');
          this.proSelectModals = false
          this.getCutPaperPasteOptFun()
        }
      })
    },
    handleChangePage(page) {
                this.pageNum = page;
                this.getCutPaperPasteListFun()
            },
            handlePageSizeChange(size) {
                this.pageSize = size;
                this.getCutPaperPasteListFun()
            },
    searchBtnSSS(){
      const data = this.$refs.tableDataSet.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      let codeArr = []
      data.map(item => {
        codeArr.push(item.code)
      })
      decalsSplits(data).then(res => {
        if (res.code == 200) {
          window.open(res.data.result,"_blank");
        }
      })
    },
    searchBtn(){
      const data = this.$refs.tableDataOneTab.getSelection();
      if (data.length === 0) {
        this.$Message.warning('请勾选数据！');
        return
      }
      let codeArr = []
      data.map(item => {
        codeArr.push(item.code)
      })
      cutCommonDecals(codeArr).then(res => {
        if (res.code == 200) {
          window.open(res.data.result,"_blank");
        }
      })
    },
    searchBtnNew() {
      // this.types = type
      this.titleType = "添加物料";
      this.proSelectModals = true
      getGoodsStockList({
        data:{
          ...this.proSelectForm,
          spId: this.objFenge.id,
          goodsWide: this.objFenge.wide,
        },
        pageNum:1,
        pageSize:9999,
        // type: type
      }).then(res => {
        if (res.code == 200) {
          this.proSelectData = res.data.records
        }
      })
    },
    getCustomerListFun(){
      getCustomerListSplitsMaterial({
        pId: this.objFenge.id,
      }).then(res => {
        if(res.code == 200){
          this.customerList = res.data

        }
      })
    },
    getNumFun(){
      getNum({
          pId: this.objFenge.id,
      }
      )
        .then(res => {
          if (res.code == 200) {
            this.numObjSvn = res.data;
          }
        })
    },
    getCutPaperPasteOptFun() {
      getSplitsMaterialList({
        data: {
          parentId: this.objFenge.id,
          dataType:1,
        },
        pageNum: 1,
        pageSize: 999,
      }
      )
        .then(res => {
          if (res.code == 200) {
            this.tableDataOne = res.data.records;
          }
        })
    },
    // searchBtn(){
    //   this.tableData = []
    //   let params = {
    //     ...this.searchForm,
    //     startTime:this.searchForm.startDate ?
    //       formatDate(this.searchForm.startDate, "yyyy-MM-dd hh:mm:ss") : "",
    //     endTime:this.searchForm.endDate ?
    //       formatDate(this.searchForm.endDate, "yyyy-MM-dd hh:mm:ss") : "",
    //   }
    //   getOverallList(params)
    //     .then(res => {
    //       if(res.code == 200){
    //           this.tableData = res.data;
    //       }
    //     })
    // },
    backPage() {
      this.$router.go(-1);
    },
    init() {
      // 初始化时间为当天
      let eTime = new Date();
      eTime.setHours("23");
      eTime.setMinutes("59");
      eTime.setSeconds("59");
      this.searchForm.endDate = eTime;
      let newTime = new Date();
      newTime.setHours("00");
      newTime.setMinutes("00");
      newTime.setSeconds("00");
      this.searchForm.startDate = newTime;


    },
  },
  mounted() {
    this.init()
    this.objFenge = JSON.parse(window.sessionStorage.getItem('objFenge'))
    console.log("objFuhe", this.objFenge);
    this.getCutPaperPasteOptFun()
    this.getCutPaperPasteListFun()
    this.getNumFun()
    this.getCustomerListFun()
  }
}
</script>




// WEBPACK FOOTER //
// src/components/fenGAdd.vue